const media_images = [
  {
    id: 2,
    photo: require("../../public/images/events/conference_1.jpeg"),
    alt: "Conference Image 1",
    title: "Conference Image 1",
    description: "Conference Image 1 description",
  },
  {
    id: 3,
    photo: require("../../public/images/events/conference_2.jpeg"),
    alt: "Conference Image 2",
    title: "Conference Image 2",
    description: "Conference Image 2 description",
  },
  {
    id: 4,
    photo: require("../../public/images/events/conference_3.jpeg"),
    alt: "Conference Image 3",
    title: "Conference Image 3",
    description: "Conference Image 3 description",
  },
  {
    id: 5,
    photo: require("../../public/images/events/conference_1.jpeg"),
    alt: "Conference Image 4",
    title: "Conference Image 4",
    description: "Conference Image 4 description",
  },
  {
    id: 6,
    photo: require("../../public/images/events/dinner_1.jpeg"),
    alt: "Dinner Image 1",
    title: "Dinner Image 1",
    description: "Dinner Image 1 description",
  },
  // Outputs – Dissemination
  {
    id: 7,
    photo: require("../../public/outputs/dissemination/diss_prod1.webp"),
    alt: "Dissemination Product - Playing Cards",
    title: "Dissemination Product - Playing Cards",
    description: "Dissemination product image",
  },
  {
    id: 8,
    photo: require("../../public/outputs/dissemination/diss_prod2.webp"),
    alt: "Dissemination Product - Playing Cards",
    title: "Dissemination Product - Playing Cards",
    description: "Dissemination product image",
  },
  {
    id: 9,
    photo: require("../../public/outputs/dissemination/diss_prod3.webp"),
    alt: "Dissemination Product - Pen and Pencil",
    title: "Dissemination Product - Pen and Pencil",
    description: "Dissemination product image",
  },
  {
    id: 10,
    photo: require("../../public/outputs/dissemination/diss_prod4.webp"),
    alt: "Dissemination Product - Bottle",
    title: "Dissemination Product - Bottle",
    description: "Dissemination product image",
  },
  {
    id: 11,
    photo: require("../../public/outputs/dissemination/diss_prod5.webp"),
    alt: "Dissemination Product - USB Drive",
    title: "Dissemination Product - USB Drive",
    description: "Dissemination product image",
  },
  {
    id: 12,
    photo: require("../../public/outputs/dissemination/diss_prod6.webp"),
    alt: "Dissemination Product - Folder",
    title: "Dissemination Product - Folder",
    description: "Dissemination product image",
  },
  {
    id: 13,
    photo: require("../../public/outputs/dissemination/diss_prod7.webp"),
    alt: "Dissemination Product - Keychain",
    title: "Dissemination Product - Keychain",
    description: "Dissemination product image",
  },
  {
    id: 14,
    photo: require("../../public/outputs/dissemination/diss_prod8.webp"),
    alt: "Dissemination Product - Tote Bag",
    title: "Dissemination Product - Tote Bag",
    description: "Dissemination product image",
  },
  // Outputs – Learning Activities / Pilot Courses
  {
    id: 15,
    photo: require("../../public/outputs/learning-activities/pilot-courses/invitation-course_c3-29.01.2026.webp"),
    alt: "Invitation – Pilot Course C3",
    title: "Invitation – Pilot Course C3",
    description: "Invitation for pilot course C3",
  },
  {
    id: 16,
    photo: require("../../public/outputs/learning-activities/pilot-courses/c1-ucv_onsite.webp"),
    alt: "C1 – UCV Onsite",
    title: "C1 – UCV Onsite",
    description: "Pilot course C1 – UCV onsite photo",
  },
  {
    id: 17,
    photo: require("../../public/outputs/learning-activities/pilot-courses/c1-ubb_onsite.webp"),
    alt: "C1 – UBB Onsite",
    title: "C1 – UBB Onsite",
    description: "Pilot course C1 – UBB onsite photo",
  },
  {
    id: 18,
    photo: require("../../public/outputs/learning-activities/pilot-courses/c1-image1.webp"),
    alt: "C1 – Image 1",
    title: "C1 – Image 1",
    description: "Pilot course C1 – Photo 1",
  },
  {
    id: 19,
    photo: require("../../public/outputs/learning-activities/pilot-courses/c1-image2.webp"),
    alt: "C1 – Image 2",
    title: "C1 – Image 2",
    description: "Pilot course C1 – Photo 2",
  },
  {
    id: 20,
    photo: require("../../public/outputs/learning-activities/pilot-courses/c1-image3.webp"),
    alt: "C1 – Image 3",
    title: "C1 – Image 3",
    description: "Pilot course C1 – Photo 3",
  },
  {
    id: 21,
    photo: require("../../public/outputs/learning-activities/pilot-courses/c1-image4.webp"),
    alt: "C1 – Image 4",
    title: "C1 – Image 4",
    description: "Pilot course C1 – Photo 4",
  },
  {
    id: 22,
    photo: require("../../public/outputs/learning-activities/pilot-courses/c2-ucv_onsite1.webp"),
    alt: "C2 – UCV Onsite 1",
    title: "C2 – UCV Onsite 1",
    description: "Pilot course C2 – UCV onsite photo 1",
  },
  {
    id: 23,
    photo: require("../../public/outputs/learning-activities/pilot-courses/c2-ucv_onsite2.webp"),
    alt: "C2 – UCV Onsite 2",
    title: "C2 – UCV Onsite 2",
    description: "Pilot course C2 – UCV onsite photo 2",
  },
  {
    id: 24,
    photo: require("../../public/outputs/learning-activities/pilot-courses/c2-ucv_onsite3.webp"),
    alt: "C2 – UCV Onsite 3",
    title: "C2 – UCV Onsite 3",
    description: "Pilot course C2 – UCV onsite photo 3",
  },
  {
    id: 25,
    photo: require("../../public/outputs/learning-activities/pilot-courses/c2-ubb_onsite.webp"),
    alt: "C2 – UBB Onsite",
    title: "C2 – UBB Onsite",
    description: "Pilot course C2 – UBB onsite photo",
  },
  {
    id: 26,
    photo: require("../../public/outputs/learning-activities/pilot-courses/c2-image1.webp"),
    alt: "C2 – Image 1",
    title: "C2 – Image 1",
    description: "Pilot course C2 – Photo 1",
  },
  {
    id: 27,
    photo: require("../../public/outputs/learning-activities/pilot-courses/c2-image2.webp"),
    alt: "C2 – Image 2",
    title: "C2 – Image 2",
    description: "Pilot course C2 – Photo 2",
  },
  {
    id: 28,
    photo: require("../../public/outputs/learning-activities/pilot-courses/c3-ucv_onsite.webp"),
    alt: "C3 – UCV Onsite",
    title: "C3 – UCV Onsite",
    description: "Pilot course C3 – UCV onsite photo",
  },
  {
    id: 29,
    photo: require("../../public/outputs/learning-activities/pilot-courses/c3-ubb_onsite.webp"),
    alt: "C3 – UBB Onsite",
    title: "C3 – UBB Onsite",
    description: "Pilot course C3 – UBB onsite photo",
  },
  {
    id: 30,
    photo: require("../../public/outputs/learning-activities/pilot-courses/c3-image1.webp"),
    alt: "C3 – Image 1",
    title: "C3 – Image 1",
    description: "Pilot course C3 – Photo 1",
  },
  {
    id: 31,
    photo: require("../../public/outputs/learning-activities/pilot-courses/c3-image2.webp"),
    alt: "C3 – Image 2",
    title: "C3 – Image 2",
    description: "Pilot course C3 – Photo 2",
  },
  {
    id: 32,
    photo: require("../../public/outputs/learning-activities/pilot-courses/c3-image3.webp"),
    alt: "C3 – Image 3",
    title: "C3 – Image 3",
    description: "Pilot course C3 – Photo 3",
  },
  {
    id: 33,
    photo: require("../../public/outputs/learning-activities/pilot-courses/c3-image4.webp"),
    alt: "C3 – Image 4",
    title: "C3 – Image 4",
    description: "Pilot course C3 – Photo 4",
  },
];

export default media_images;
